import { render, staticRenderFns } from "./detallesMantenimientosAlistamiento.vue?vue&type=template&id=164003fe&scoped=true"
import script from "./detallesMantenimientosAlistamiento.vue?vue&type=script&lang=js"
export * from "./detallesMantenimientosAlistamiento.vue?vue&type=script&lang=js"
import style0 from "./detallesMantenimientosAlistamiento.vue?vue&type=style&index=0&id=164003fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164003fe",
  null
  
)

export default component.exports